/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState } from 'react';

import { fixPhoneNumber } from '../../utils/common';
import { Logo } from '../Logo/Logo';
import { MessengerIcon } from '../Icons/MessengerIcon';
import { useAppConfigContext } from '../../hooks/useAppConfigContext';
import { Terms } from '../Terms/Terms';

import styles from './Footer.module.css';

export const Footer = () => {
  const config = useAppConfigContext();
  const [open, setOpen] = useState(false);

  const openDialog = () => setOpen(true);

  const closeDialog = () => setOpen(false);

  return (
    <footer className="text-light">
      <section className={styles.firstSection}>
        <h4 className={styles.title}>Обсудить проект</h4>
        <div className={styles.iconsGroup}>
          <MessengerIcon type="telegram" />
          <MessengerIcon key="vk" type="vk" />
        </div>
      </section>
      <section className={styles.secondSection}>
        <ul className={styles.list}>
          <li className="underline">
            <a
              href={`mailto:${config.email}?subject=Обсуждение проекта&body=Добрый день, Павел.`}
              className="glow"
            >
              {config.email}
            </a>
          </li>
          <li>
            <a
              href={`tel:${fixPhoneNumber(config.phoneNumber)}`}
              className="glow"
            >
              {config.phoneNumber}
            </a>
          </li>
          <li className="glow hover:cursor-pointer" onClick={openDialog}>
            Kонфидециальность
          </li>
        </ul>
        <div className={styles.bottomContainer}>
          <Logo className={styles.logo} size="sm" />
          <div className={styles.organization}>
            <p>
              {config.organization} | {config.OGRN}
            </p>
          </div>
          <nav>
            <ul className={styles.navList}>
              <li>
                <MessengerIcon key="vk" type="vk" className={styles.text} />
              </li>
              <li>
                <MessengerIcon
                  key="youtube"
                  type="youtube"
                  className={styles.text}
                />
              </li>
              <li>
                <MessengerIcon
                  key="behance"
                  type="behance"
                  className={styles.text}
                />
              </li>
              <li>
                <MessengerIcon
                  key="telegram"
                  type="telegram"
                  className={styles.text}
                />
              </li>
            </ul>
          </nav>
        </div>
      </section>
      <Terms open={open} onClose={closeDialog} />
    </footer>
  );
};
